<app-content-header i18n-title title="Payments" i18n-subTitle
                    subTitle="An overview of all bookings with payments"
                    [backgroundImage]="backgroundImage"
                    [containerClass]="containerClass"
                    [subContainerClass]="subContainerClass"
                    [pyClass]="pyClass"
                    [contentClass]="contentClass"
                    [h1class]="h1class"
                    [h2class]="h2class"
                    [subContainerBackgroundImage]="subContainerBackgroundImage"
                    [containerBackgroundImage]="containerBackgroundImage"
></app-content-header>

<app-content-breadcrumb [elements]="breadCrumbElements"></app-content-breadcrumb>
<div class="content">
  <div class="row">
    <div class="col-md-12">
      <div class="block block-bordered">
        <div class="block-header block-header-default">
          <h3 class="block-title">Filter</h3>
        </div>

        <!-- -->
        <div class="block-content block-content-full">
          <form [formGroup]="form" (ngSubmit)="loadBookingPaymentList()">

            <div class="row">
              <label class="col-lg-3 col-form-label" for="date">Date</label>
              <div class="col-lg-9">
                <input type="text" class="form-control" id="date" name="date"
                       placeholder="Enter a start date" bsDatepicker formControlName="date"
                       [bsConfig]="{ dateInputFormat: 'YYYY-MM-DD', adaptivePosition: true }">
              </div>
            </div>

            <div class="row">
              <label class="col-lg-3 col-form-label" for="id">Id</label>
              <div class="col-lg-9">
                <input type="text" class="form-control"
                       placeholder="Ids you want to search for (Booking, Request, Housing etc)"
                       autocomplete="off"
                       id="id"
                       formControlName="id">
              </div>
            </div>

            <div class="row">
              <label class="col-lg-3 col-form-label" for="id">Username</label>
              <div class="col-lg-9">
                <input type="text" class="form-control"
                       placeholder="A username you want to search for"
                       autocomplete="off"
                       id="username"
                       formControlName="username">
              </div>
            </div>

            <div class="row">
              <label class="col-lg-3 col-form-label" for="paymentStateUser">Payment State (User)</label>
              <div class="col-lg-9">
                <select class="form-control" formControlName="paymentStateUser" id="paymentStateUser">
                  <option></option>
                  <option value="open">Open</option>
                  <option value="pending">Pending</option>
                  <option value="authorized">Authorized</option>
                  <option value="paid">Paid</option>
                  <option value="canceled">Canceled</option>
                  <option value="expired">Expired</option>
                  <option value="failed">Failed</option>
                </select>
              </div>
            </div>

            <div class="row">
              <label class="col-lg-3 col-form-label" for="payoutStatePartner">Payment State (Partner)</label>
              <div class="col-lg-9">
                <select class="form-control" formControlName="payoutStatePartner" id="payoutStatePartner">
                  <option></option>
                  <option value="CREATED">Created</option>
                  <option value="PENDING">Pending</option>
                  <option value="COMPLETED">Completed</option>
                  <option value="REVERTED">Reverted</option>
                  <option value="DECLINED">Declined</option>
                  <option value="CANCELLED">Cancelled</option>
                  <option value="FAILED">Failed</option>
                  <option value="DELETED">Deleted</option>
                </select>
              </div>
            </div>

            <div class="row">
              <label class="col-lg-3 col-form-label" for="currency">Currency</label>
              <div class="col-lg-9">
                <select class="form-control" formControlName="currency" id="currency">
                  <option></option>
                  <option *ngFor="let currency of currencies">{{ currency }}</option>
                </select>
              </div>
            </div>

            <div class="row">
              <label class="col-lg-3">Status</label>
              <div class="col-lg-9">

                <div class="custom-control custom-checkbox custom-control-inline mb-5">
                  <input class="custom-control-input" type="checkbox" name="bples_new"
                         id="bples_new"
                         formControlName="bples_new">
                  <label class="custom-control-label" for="bples_new">New</label>
                </div>

                <div class="custom-control custom-checkbox custom-control-inline mb-5">
                  <input class="custom-control-input" type="checkbox" name="bples_user_payment_is_due"
                         id="bples_user_payment_is_due"
                         formControlName="bples_user_payment_is_due">
                  <label class="custom-control-label" for="bples_user_payment_is_due">User Payment is due</label>
                </div>

                <div class="custom-control custom-checkbox custom-control-inline mb-5">
                  <input class="custom-control-input" type="checkbox" name="bples_partner_payment_is_due"
                         id="bples_partner_payment_is_due"
                         formControlName="bples_partner_payment_is_due">
                  <label class="custom-control-label" for="bples_partner_payment_is_due">Partner Payment is due</label>
                </div>

                <div class="custom-control custom-checkbox custom-control-inline mb-5">
                  <input class="custom-control-input" type="checkbox" name="bples_deadline_mismatch"
                         id="bples_deadline_mismatch"
                         formControlName="bples_deadline_mismatch">
                  <label class="custom-control-label" for="bples_deadline_mismatch">Deadline Mismatch</label>
                </div>

                <div class="custom-control custom-checkbox custom-control-inline mb-5">
                  <input class="custom-control-input" type="checkbox" name="bples_partner_missing_bank_details"
                         id="bples_partner_missing_bank_details"
                         formControlName="bples_partner_missing_bank_details">
                  <label class="custom-control-label" for="bples_partner_missing_bank_details">Partner Missing Bank
                    Details</label>
                </div>

                <div class="custom-control custom-checkbox custom-control-inline mb-5">
                  <input class="custom-control-input" type="checkbox" name="bples_finished"
                         id="bples_finished"
                         formControlName="bples_finished">
                  <label class="custom-control-label" for="bples_finished">Finished</label>
                </div>

                <div class="custom-control custom-checkbox custom-control-inline mb-5">
                  <input class="custom-control-input" type="checkbox" name="bples_cancelled"
                         id="bples_cancelled"
                         formControlName="bples_cancelled">
                  <label class="custom-control-label" for="bples_cancelled">Cancelled</label>
                </div>

              </div>
            </div>

            <div class="row">
              <label class="col-lg-3 col-form-label" for="sorting">Sorting</label>
              <div class="col-lg-9">
                <select class="form-control" formControlName="sorting" id="sorting">
                  <option></option>
                  <option value="HOUSING_NAME">Housing Name</option>
                  <option value="DEADLINE_USER">Deadline User</option>
                  <option value="DEADLINE_PARTNER">Deadline Partner</option>
                  <option value="DEADLINE_CANCELLATION">Deadline Cancellation</option>
                  <option value="CHECKIN">Check In</option>
                </select>
              </div>
            </div>

          </form>
        </div>
        <div class="block-content block-content-sm block-content-full bg-body-light font-size-sm text-left">
          <div class="row">
            <div class="col-12">
              <button class="btn btn-info btn-sm" (click)="loadBookingPaymentList()">Apply Filter</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12">
      <div class="block block-bordered">
        <div class="block-header block-header-default">
          <h3 class="block-title">Payments overview</h3>
        </div>
        <div class="block">
          <div class="table-responsive" style="max-height: 700px; overflow-y: auto; font-size: 0.85em; color:#000000;">
            <table class="table table-sm mb-0">
              <thead class="sticky-header">
              <tr>
                <th style="min-width:75px" class="header" scope="col">Created</th>
                <th scope="col">BookingId</th>
                <th scope="col">RequestId</th>
                <th scope="col">OfferId</th>
                <th scope="col">HousingId</th>
                <th style="min-width:150px" scope="col">Housing</th>
                <th scope="col">Status</th>
                <th style="min-width:100px" scope="col">Mollie Status</th>
                <th scope="col">Transfer</th>
                <th scope="col">Currency</th>
                <th style="min-width:75px" scope="col">DL Cancel</th>
                <th style="min-width:75px" scope="col">DL User</th>
                <th style="min-width:85px" scope="col">DL Partner</th>
                <th style="min-width:75px" scope="col">CheckIn</th>
                <th scope="col">Firstname</th>
                <th scope="col">Lastname</th>
                <th scope="col">PAX</th>
                <th style="min-width:150px" scope="col">BA Holder</th>
                <th scope="col">BA Iban</th>
                <th scope="col">BA Bank</th>
                <th scope="col">BA BIC</th>
                <th scope="col"></th>
              </tr>
              </thead>
              <tbody *ngIf="elements != null && pagination != null">
              <tr *ngFor="let element of elements | paginate: {
              itemsPerPage: pagination.limit,
              currentPage: pagination.page,
              totalItems: pagination.total}"
                  [ngClass]="{
                  'table-warning-custom': element.state === 'USER_PAYMENT_IS_DUE',
                  'bg-warning': element.state === 'PARTNER_PAYMENT_IS_DUE',
                  'bg-info': element.state === 'DEADLINE_MISMATCH',
                  'bg-danger': element.state === 'PARTNER_MISSING_BANK_DETAILS',
                  'bg-success': element.state === 'FINISHED',
                  'table': element.state === 'CANCELLED'
              }">
                <td>{{ element.bookingDate }}</td>
                <td>{{ element.bookingId }}</td>
                <td>{{ element.requestId }}</td>
                <td>{{ element.offerId }}</td>
                <td>{{ element.housingId }}</td>
                <td>{{ element.housingName }}</td>
                <td>{{ element.state }}</td>
                <td>{{ element.userPaymentState }}</td>
                <td class="text-right">
                  <span *ngIf="element.toTransfer != null">{{ element.toTransfer.toFixed(2) }}</span>
                </td>
                <td>{{ element.currency }}</td>
                <td>{{ element.deadlineCancellation }}</td>
                <td>{{ element.deadlineUser }}</td>
                <td>{{ element.deadlinePartner }}</td>
                <td>{{ element.checkIn }}</td>
                <td>{{ element.firstNameUser }}</td>
                <td>{{ element.lastNameUser }}</td>
                <td>{{ element.totalPersons }}</td>
                <td>{{ element.bankDetails.holderName }}</td>
                <td>{{ element.bankDetails.iban }}</td>
                <td>{{ element.bankDetails.bankName }}</td>
                <td>{{ element.bankDetails.bic }}</td>
                <td>
                  <button class="btn btn-sm btn-primary" (click)="requestBookingPaymentDetails(element.bookingId)">
                    <i class="fa fa-info"></i>
                  </button>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="block-content block-content-sm bg-body-light font-size-sm text-center">
          <pagination-controls [maxSize]="10"
                               (pageChange)="sendPage($event)"
                               *ngIf="pagination != null">
          </pagination-controls>
        </div>
      </div>
    </div>
  </div>
</div>
<tripmakery-booking-payment-details-modal></tripmakery-booking-payment-details-modal>
